<div class="container-fuild h-100 p-3">
  <wkt-info
    [mainInfo]="mainInfo"
    [buttonLabel]="buttonLabel"
    [buttonUrl]="buttonUrl"
    (buttonAction)="clickButton($event)"></wkt-info>
</div>
